import { createApp } from 'vue'
import App from './App.vue'
import './styles/reset.scss'

createApp(App).mount('#app')
